import { jsx as a, Fragment as E, jsxs as m } from "react/jsx-runtime";
import { withManagedProps as N } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as g } from "@made-people/react-prop-guard";
import k, { useEffect as fe, createElement as He, isValidElement as Me, useState as J } from "react";
import { g as $e, b as qe, w as Ge, d as U, s as Qe, q as Ve, a as ye, c as Fe, e as Re, f as ce, t as W, p as Ue, h as P } from "./blueprint-c8c0059d.mjs";
import { useProductBase as T, useProductImages as we, useProductProviderContext as Xe, ProductLink as le, useProductPriceInfo as ue, useProductAttributeGetter as ve, useProductSiblings as Ze, useProductOptions as X, useProductHasOptionsInStock as de, useProductPurchaseStatus as ne, useProductDataModel as Se, useIsBundle as Ye, useProductAttribute as Je } from "@made-people/grease-product";
import j, { clsx as et } from "clsx";
import { responsiveImageSchema as tt, ResponsiveImage as Ie } from "@made-people/blueprint-responsive-image";
import { useTranslate as A } from "@made-people/grease-translations";
import { Badge as M, badgeSchema as ee } from "@made-people/blueprint-badge";
import { AnimatePresence as at, motion as Ce } from "motion/react";
import { buttonAsButtonSchema as $, ButtonAsButton as q, buttonContentPropsSchema as ot, Button as nt } from "@made-people/blueprint-button";
import { useQuickShopAddToCart as rt, useUpdateCart as re } from "@made-people/grease-cart";
import { overlayEventEmitter as G } from "@made-people/blueprint-overlay";
import { toast as he } from "sonner";
import { Drawer as se } from "@made-people/blueprint-drawer";
import "@made-people/blueprint";
const it = (e, n) => {
  fe(() => {
    if (!n || !e.current || sessionStorage.getItem("swipe-hint-seen"))
      return;
    const r = setTimeout(() => {
      if (!e.current)
        return;
      const i = e.current.querySelector(
        "[data-product-card-gallery]"
      );
      !i || i.children.length <= 1 || sessionStorage.getItem("swipe-hint-seen") || (sessionStorage.setItem("swipe-hint-seen", "true"), i.style.scrollSnapType = "none", i.style.overflowX = "hidden", i.scrollTo({
        left: i.clientWidth * 0.4,
        behavior: "smooth"
      }), setTimeout(() => {
        i.scrollTo({
          left: 0,
          behavior: "smooth"
        }), setTimeout(() => {
          i.style.scrollSnapType = "", i.style.overflowX = "";
        }, 500);
      }, 800));
    }, 1e3);
    return () => clearTimeout(r);
  }, [n, e]);
}, st = (e, n, o = []) => {
  const [r, i] = k.useState(!0), [s, c] = k.useState(!1), l = k.useCallback(() => e.current ? e.current.querySelector(n) : null, [e, n]), u = k.useCallback(() => {
    const d = l();
    if (!d) {
      i(!0), c(!0);
      return;
    }
    const p = d.scrollWidth - d.clientWidth;
    if (p <= 0) {
      i(!0), c(!0);
      return;
    }
    const b = d.scrollLeft, h = 1;
    i(b <= h), c(b >= p - h);
  }, [l]);
  return k.useEffect(() => {
    u();
    const d = l();
    if (!d)
      return;
    const p = () => u();
    return d.addEventListener("scroll", p, { passive: !0 }), window.addEventListener("resize", u), () => {
      d.removeEventListener("scroll", p), window.removeEventListener("resize", u);
    };
  }, [l, u, ...o]), { isAtStart: r, isAtEnd: s, update: u };
}, ct = ({
  imagesCount: e,
  scrollPosition: n,
  slots: o
}) => /* @__PURE__ */ a(E, { children: Array.from({ length: e }).map((r, i) => {
  const s = Math.round(n) === i;
  return /* @__PURE__ */ a(
    "div",
    {
      role: "tab",
      "aria-selected": s,
      "aria-label": `Image ${i + 1} of ${e}`,
      className: j(
        o.indicatorDot,
        s && o.indicatorDotActive
      )
    },
    i
  );
}) }), lt = ({
  imagesCount: e,
  scrollPosition: n,
  slots: o
}) => /* @__PURE__ */ m("div", { className: o.indicatorScrollbarContainer, "aria-hidden": "true", children: [
  Array.from({ length: e }).map((r, i) => /* @__PURE__ */ a("div", { className: j(o.indicatorScrollbar, "flex-1") }, i)),
  /* @__PURE__ */ a(
    "div",
    {
      className: j(
        o.indicatorScrollbarActive,
        o.indicatorScrollbarOverlay
      ),
      style: {
        left: `${n / e * 100}%`,
        width: `${100 / e}%`
      }
    }
  )
] }), ut = ({
  imagesCount: e,
  scrollPosition: n,
  type: o,
  slots: r
}) => e <= 1 ? null : /* @__PURE__ */ a(
  "div",
  {
    className: r.indicatorWrapper,
    role: "tablist",
    "aria-label": "Image navigation",
    children: o === "scrollbar" ? /* @__PURE__ */ a(
      lt,
      {
        imagesCount: e,
        scrollPosition: n,
        slots: r
      }
    ) : /* @__PURE__ */ a(
      ct,
      {
        imagesCount: e,
        scrollPosition: n,
        slots: r
      }
    )
  }
), me = t.object({
  className: t.string().optional(),
  imageSettings: tt.optional(),
  variants: t.custom().optional().describe("Variants for the gallery"),
  styling: t.custom().optional().describe("If you want to override the default styling"),
  swipeHint: t.boolean().optional().describe("If you want to enable the swipe hint"),
  arrowNavigation: t.object({
    enabled: t.boolean().optional(),
    leftIcon: t.custom().optional(),
    rightIcon: t.custom().optional()
  }).optional().describe("If you want to enable the scroll arrows"),
  indicator: t.object({
    enabled: t.boolean().optional(),
    showOnMobileOnly: t.boolean().optional(),
    type: t.enum(["dots", "scrollbar"]).optional()
  }).optional(),
  children: t.custom().optional()
}), ke = g(me, (e) => {
  var Y, _, H, L, C;
  const n = T(), o = we(), r = Xe(), i = k.useRef(null), [s, c] = k.useState(0), l = Math.round(s), u = r.type === "plp" && (() => {
    var z, K;
    const v = ((z = r.listId) == null ? void 0 : z.toLowerCase()) ?? "", I = ((K = r.listName) == null ? void 0 : K.toLowerCase()) ?? "";
    return v === "swipeable-product-list" || I === "swipeable product list" || v.includes("swipeable-product-list") || I.includes("swipeable product list");
  })(), d = !u, p = (e.swipeHint ?? !1) && !u && r.type === "plp" && r.position === 0;
  it(i, p);
  const b = e.styling ?? $e, h = k.useMemo(
    () => u ? { ...e.variants ?? {}, hoverEffect: "changeImage" } : e.variants,
    [u, e.variants]
  ), w = b.styles(h), f = d && ((Y = e.indicator) == null ? void 0 : Y.enabled) && ((o == null ? void 0 : o.length) ?? 0) > 1, S = d && ((_ = e.arrowNavigation) == null ? void 0 : _.enabled) && ((o == null ? void 0 : o.length) ?? 0) > 1, B = 4, O = r.type === "plp" && r.position < B, { isAtStart: D, isAtEnd: y } = st(
    i,
    "[data-product-card-gallery]",
    [o == null ? void 0 : o.length]
  );
  k.useEffect(() => {
    if (!f || !i.current)
      return;
    const v = i.current.querySelector(
      "[data-product-card-gallery]"
    );
    if (!v)
      return;
    const I = () => {
      const z = v.scrollLeft, K = v.clientWidth, ie = z / K;
      c(ie);
    };
    return I(), v.addEventListener("scroll", I, { passive: !0 }), () => v.removeEventListener("scroll", I);
  }, [f, o == null ? void 0 : o.length]);
  const Z = ({ direction: v }) => {
    if (!i.current)
      return;
    const I = i.current.querySelector(
      "[data-product-card-gallery]"
    );
    if (!I)
      return;
    const K = I.clientWidth;
    I.scrollBy({
      left: v === "left" ? -K : K,
      top: 0,
      behavior: "smooth"
    });
  };
  return o ? /* @__PURE__ */ m(
    "div",
    {
      className: j(e.className, w.wrapper),
      ref: i,
      role: "region",
      "aria-label": `Product images, ${(o == null ? void 0 : o.length) || 0} images`,
      "aria-roledescription": "carousel",
      children: [
        S && /* @__PURE__ */ m(E, { children: [
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              "aria-label": `Previous image${o && o.length > 1 ? `, currently showing image ${l + 1} of ${o.length}` : ""}`,
              className: w.leftArrow,
              onClick: () => Z({ direction: "left" }),
              disabled: D,
              "aria-disabled": D,
              children: (H = e.arrowNavigation) == null ? void 0 : H.leftIcon
            }
          ),
          /* @__PURE__ */ a(
            "button",
            {
              type: "button",
              "aria-label": `Next image${o && o.length > 1 ? `, currently showing image ${l + 1} of ${o.length}` : ""}`,
              className: w.rightArrow,
              onClick: () => Z({ direction: "right" }),
              disabled: y,
              "aria-disabled": y,
              children: (L = e.arrowNavigation) == null ? void 0 : L.rightIcon
            }
          )
        ] }),
        /* @__PURE__ */ a(
          le,
          {
            productBase: n,
            context: "product-card",
            className: w.imageWrapper,
            "aria-label": `View ${n.content.name || "product"} details`,
            "data-product-card-gallery": !0,
            "data-multiple-images": (o == null ? void 0 : o.length) > 1 ? "true" : "false",
            role: "group",
            "aria-roledescription": "slide",
            children: o.map((v, I) => {
              const K = O && I === 0, ie = K ? "eager" : "lazy", _e = K ? "high" : "auto";
              return /* @__PURE__ */ a(
                Ie,
                {
                  displaySize: { mobile: "50vw", desktop: "25vw" },
                  image: { src: v.src, alt: v.alt },
                  className: w.image,
                  ...e.imageSettings,
                  loading: ie,
                  fetchpriority: _e,
                  "aria-label": `${v.alt || n.content.name || "Product image"} ${o.length > 1 ? `${I + 1} of ${o.length}` : ""}`
                },
                I
              );
            })
          }
        ),
        /* @__PURE__ */ a(
          "div",
          {
            className: "sr-only",
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true",
            children: o && o.length > 1 && `Viewing image ${l + 1} of ${o.length}`
          }
        ),
        f && /* @__PURE__ */ a(
          ut,
          {
            imagesCount: o.length,
            scrollPosition: s,
            type: (C = e.indicator) == null ? void 0 : C.type,
            slots: w
          }
        ),
        e.children
      ]
    }
  ) : null;
}), Q = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  discountBadge: t.object({
    enabled: t.boolean().optional(),
    variants: t.custom().optional()
  }).optional(),
  location: t.enum(["gallery", "details"]).optional().describe(
    "Where the component is placed in the DOM so we can make our magic swap"
  ),
  placeIn: t.enum(["gallery", "details"]).optional().describe("Where to place the badges in the DOM"),
  showWithDiscount: t.boolean().optional()
}), te = N(
  "ProductCardBadges",
  g(
    {
      schema: Q,
      defaultProps: {
        location: "gallery",
        placeIn: "gallery",
        showWithDiscount: !0
      }
    },
    ({
      variants: e,
      location: n,
      placeIn: o,
      styling: r,
      discountBadge: i,
      className: s,
      showWithDiscount: c
    }) => {
      var f;
      const {
        content: { badges: l }
      } = T(), u = ue(), d = A(), p = u.price.number < u.priceWithoutDiscount.number;
      if (n !== o)
        return;
      const h = (r ?? qe).styles({
        ...e,
        placeIn: o ?? "gallery"
      }), w = (i == null ? void 0 : i.enabled) && p;
      return !l.length && !w ? null : /* @__PURE__ */ m("div", { className: j(s, h.wrapper), children: [
        w && /* @__PURE__ */ a(
          M,
          {
            label: d("PLP_Discount_Badge", {
              saveAmount: u.priceWithoutDiscount.number - u.price.number,
              saveProcentage: `${(f = u.discountInfo) == null ? void 0 : f.percent}%`
            }),
            variants: i.variants
          }
        ),
        (c || !w) && l.map((S, B) => /* @__PURE__ */ a(
          "span",
          {
            className: h.badge,
            "data-type": S.badgeType,
            style: {
              backgroundColor: S.backgroundColor ?? "",
              color: S.textColor ?? ""
            },
            children: S.label
          },
          B
        ))
      ] });
    }
  )
), dt = ({ on: e }) => /* @__PURE__ */ m(E, { children: [
  /* @__PURE__ */ m("svg", { viewBox: "0 0 24 24", className: "overflow-visible w-7 h-7", children: [
    /* @__PURE__ */ a(
      "use",
      {
        xlinkHref: "#heart",
        className: et(
          "fill-transparent transition-all stroke-1",
          e ? "stroke-transparent" : "stroke-gray-700"
        )
      }
    ),
    /* @__PURE__ */ a(at, { initial: !1, children: e && /* @__PURE__ */ a(
      Ce.use,
      {
        xlinkHref: "#heart",
        className: "fill-red-500 stroke-red-500 origin-center",
        initial: { opacity: 0, scale: 0.2 },
        animate: { opacity: 1, scale: 1 },
        exit: { opacity: 0, scale: 0.2 },
        transition: { duration: 0.5, ease: [0.19, 2.41, 0.45, 0.94] }
      }
    ) })
  ] }),
  /* @__PURE__ */ a("svg", { className: "hidden", viewBox: "0 0 512 512", children: /* @__PURE__ */ a("defs", { children: /* @__PURE__ */ a(
    "path",
    {
      id: "heart",
      d: "M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z"
    }
  ) }) })
] }), V = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  enabled: t.boolean().optional(),
  triggerIcon: t.union([t.string(), t.custom()]).optional()
}), Ia = g(V, (e) => {
  if (!e.enabled)
    return null;
  const n = Ge.styles(e.variants), o = e.triggerIcon || /* @__PURE__ */ a(dt, { on: !1 });
  return /* @__PURE__ */ a("div", { className: e.className + " " + n.wrapper, children: o });
}), pe = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  children: t.custom().optional()
}), De = g(pe, (e) => {
  const n = T(), r = (e.styling ?? U).styles(e.variants);
  return /* @__PURE__ */ m("div", { className: r.detailsWrapper, children: [
    e.children,
    /* @__PURE__ */ a(
      le,
      {
        productBase: n,
        className: r.detailsLink,
        context: "product-card",
        "aria-label": "View product details"
      }
    )
  ] });
}), mt = t.object({
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), Ke = g(mt, (e) => {
  const {
    content: { name: n }
  } = T(), r = (e.styling ?? U).styles(e.variants);
  return /* @__PURE__ */ a("h4", { className: r.name, children: n });
}), pt = (e) => {
  var n, o, r;
  return /* @__PURE__ */ m(E, { children: [
    !e.isDiscounted && /* @__PURE__ */ a(
      M,
      {
        className: e.slots.price,
        label: e.priceInfo.price.formatted,
        ...(n = e.badge) == null ? void 0 : n.default
      }
    ),
    e.isDiscounted && /* @__PURE__ */ m(E, { children: [
      /* @__PURE__ */ a(
        M,
        {
          className: e.slots.price,
          label: e.priceInfo.price.formatted,
          ...(o = e.badge) == null ? void 0 : o.discounted
        }
      ),
      /* @__PURE__ */ a(
        M,
        {
          className: e.slots.priceBeforeDiscount,
          label: e.priceInfo.priceWithoutDiscount.formatted,
          ...(r = e.badge) == null ? void 0 : r.default
        }
      )
    ] })
  ] });
}, gt = (e) => /* @__PURE__ */ m(E, { children: [
  /* @__PURE__ */ a(
    "span",
    {
      "data-is-discounted": e.isDiscounted ? "true" : "false",
      className: e.slots.price,
      children: e.priceInfo.price.formatted
    }
  ),
  e.isDiscounted && /* @__PURE__ */ a("span", { className: e.slots.priceBeforeDiscount, children: e.priceInfo.priceWithoutDiscount.formatted })
] }), F = t.object({
  as: t.enum(["badge", "span"]).optional(),
  badge: t.object({
    default: ee.optional(),
    discounted: ee.optional()
  }).optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), Ne = g(F, (e) => {
  const n = ue();
  if (!n)
    return null;
  const r = (e.styling ?? U).styles(e.variants), i = n.price.number < n.priceWithoutDiscount.number, s = {
    priceInfo: n,
    isDiscounted: i,
    slots: r
  }, c = e.as ?? "span";
  return /* @__PURE__ */ m("div", { className: r.priceWrapper, children: [
    c === "badge" && /* @__PURE__ */ a(pt, { ...s, badge: e.badge }),
    c === "span" && /* @__PURE__ */ a(gt, { ...s })
  ] });
}), ht = (e) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(e), bt = (e) => /^[a-zA-Z]+$/.test(e) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(e), ft = (e) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(e) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(e), yt = (e) => e.startsWith("http") || e.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(e), wt = ({
  sibling: e,
  productSwatchAttribute: n,
  className: o
}) => {
  const r = T(), i = ve(e);
  if (!e || !n)
    return null;
  const s = i(
    n,
    t.string()
  );
  if (!s)
    return null;
  const c = s.valueLabel, l = s.value, u = () => l ? yt(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : ht(l) || bt(l) || ft(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {};
  return /* @__PURE__ */ a(
    le,
    {
      productBase: e,
      className: o,
      context: "product-sibling",
      "aria-label": `Go to ${c} product`,
      "data-is-white": l === "#ffffff" || (c == null ? void 0 : c.toLocaleLowerCase()) === "white" || (c == null ? void 0 : c.toLocaleLowerCase()) === "vit",
      style: u(),
      "data-selected": r.productId === e.productId
    }
  );
}, R = t.object({
  className: t.string().optional(),
  variants: t.custom().optional().describe("Variants for the swatches"),
  productSwatchAttribute: t.string().optional().describe("What attribute to use for the swatch color"),
  maxSwatches: t.number().optional().describe(
    "Maximum number of swatches to display. Remaining count shown as +N."
  ),
  location: t.enum(["gallery", "details"]).optional().describe(
    "Where the component is placed in the DOM so we can make our magic swap"
  ),
  placeIn: t.enum(["gallery", "details"]).optional().describe("Where to place the swatches in the DOM")
}), ae = N(
  "ProductCardSwatches",
  g(
    {
      schema: R,
      defaultProps: {
        productSwatchAttribute: "colorSwatchHex",
        placeIn: "gallery"
      }
    },
    (e) => {
      if (e.location !== e.placeIn)
        return;
      const n = Ze(), o = Qe.styles({
        ...e.variants,
        placeIn: e.placeIn ?? "gallery"
      });
      if (!n.length)
        return null;
      const r = e.maxSwatches != null ? n.slice(0, e.maxSwatches) : n, i = n.length - r.length;
      return /* @__PURE__ */ a("div", { className: j(e.className, o.wrapper), children: /* @__PURE__ */ m("div", { className: o.swatches, children: [
        r.map((s) => /* @__PURE__ */ a(
          wt,
          {
            sibling: s,
            productSwatchAttribute: e.productSwatchAttribute,
            className: o.swatch
          },
          s.productId
        )),
        i > 0 && /* @__PURE__ */ m("span", { className: o.overflow, children: [
          "+",
          i
        ] })
      ] }) });
    }
  )
), ge = t.object({
  variants: t.custom().optional(),
  styling: t.custom().optional(),
  dataKey: t.literal("shortDescription").optional(),
  attributeKey: t.string().optional()
}), vt = g(ge, (e) => {
  var c;
  const n = T(), o = ve(n);
  let r;
  e.dataKey && (r = n.content[e.dataKey]), e.attributeKey && (r = (c = o(e.attributeKey, t.string())) == null ? void 0 : c.value);
  const s = (e.styling ?? U).styles(e.variants);
  return r ? /* @__PURE__ */ a("p", { className: s.productInfoText, children: r }) : null;
}), St = t.object({
  option: t.custom(),
  optionGroup: t.custom(),
  className: t.string().optional(),
  buttons: $.optional(),
  postAddAction: t.union([t.literal("showMinicart"), t.literal("none")]).optional().describe("Action to perform after adding the product to the cart"),
  action: t.union([t.literal("addToCart"), t.literal("selectOption")]).optional()
}), Pe = N(
  "QuickshopButton",
  g(
    St,
    ({ buttons: e, option: n, className: o, optionGroup: r, action: i, postAddAction: s }) => {
      var S;
      const { quickAddToCartMethod: c } = rt(), { selectOption: l, optionGroups: u, selectedOptions: d } = X(), p = typeof window < "u" && window.location.pathname.includes("/checkout"), h = u.length > 1 || i === "selectOption" ? () => l(r.dimensionKey, n) : n.inventory.inStock ? () => c.execute(n).then(() => {
        s === "showMinicart" && !p && G.emit("open", {
          overlayId: "mini-cart"
        });
      }) : () => l(r.dimensionKey, n), w = ((S = d[r.dimensionKey]) == null ? void 0 : S.dimensionValue) === n.dimensionValue, f = !n.inventory.inStock;
      return /* @__PURE__ */ a(
        q,
        {
          onClick: h,
          className: o,
          label: n.label,
          progress: c.loadingState,
          dataAttr: {
            "is-selected": !!w,
            "appear-disabled": !!f,
            "is-out-of-stock": !!f
          },
          ...e
        },
        n.label
      );
    }
  )
), xe = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  buttons: $.optional(),
  postAddAction: t.union([t.literal("showMinicart"), t.literal("none")]).optional().describe("Action to perform after adding the product to the cart")
}), It = N(
  "ProductCardQuickshopButtonGrid",
  g(
    {
      schema: xe,
      defaultProps: {
        template: "button-grid",
        buttons: {
          variants: {
            style: "transparent",
            color: "secondary",
            size: "sm"
          }
        }
      }
    },
    ({ variants: e, buttons: n, postAddAction: o }) => {
      const r = Ve.styles(e), i = X();
      return de(), /* @__PURE__ */ a("div", { className: r.base, children: i.optionGroups.map((s) => /* @__PURE__ */ a("div", { className: r.wrapper, children: s.options.map((c, l) => /* @__PURE__ */ a(
        Pe,
        {
          postAddAction: o,
          option: c,
          optionGroup: s,
          className: r.size,
          buttons: n
        },
        `${c.label}-${l}`
      )) }, s.dimensionKey)) });
    }
  )
), Ct = () => /* @__PURE__ */ m(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ a("defs", {}),
      /* @__PURE__ */ a("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), kt = () => /* @__PURE__ */ m(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ a("defs", {}),
      /* @__PURE__ */ a("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), Ee = t.object({
  variants: t.custom().optional(),
  incrementWith: t.number().optional().describe("The number to increment with"),
  inputFieldIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional(),
  plusButtonVariants: t.any().optional().describe("Variants for the plus button"),
  minusButtonVariants: t.any().optional()
}), Te = t.object({
  template: t.literal("increment"),
  variants: t.custom().optional(),
  increments: t.array(Ee).optional(),
  // Solve the issue with error TS7056: The inferred type of this node exceeds the maximum length the compiler will serialize. An explicit type annotation is needed.
  plusButtonVariants: t.any().optional().describe("Variants for the plus button"),
  minusButtonVariants: t.any().optional()
}), Dt = g(
  Ee,
  ({
    incrementWith: e = 1,
    inputFieldIcon: n,
    minusButtonVariants: o,
    plusButtonVariants: r,
    variants: i
  }) => {
    const s = ye.styles(i), c = A(), {
      quantityInCart: l,
      addToCartMethod: u,
      removeFromCartMethod: d,
      isAvailable: p
    } = re(), b = () => typeof n == "string" || Me(n) ? n : typeof n == "function" ? /* @__PURE__ */ a(n, {}) : null;
    return /* @__PURE__ */ m("div", { className: s.container, children: [
      /* @__PURE__ */ a(
        q,
        {
          progress: d.loadingState,
          iconLeft: /* @__PURE__ */ a(Ct, {}),
          variants: o,
          disabled: l < e,
          onClick: () => d.execute(e)
        }
      ),
      /* @__PURE__ */ m("div", { className: s.inputFieldWrapper, children: [
        n && /* @__PURE__ */ a("span", { className: s.inputFieldIcon, children: b() }),
        /* @__PURE__ */ a("span", { className: s.inputField, children: e }),
        /* @__PURE__ */ a("span", { className: s.numberSuffix, children: c("Quickshop_Increment_Number_Suffix") })
      ] }),
      /* @__PURE__ */ a(
        q,
        {
          progress: u.loadingState,
          iconLeft: /* @__PURE__ */ a(kt, {}),
          variants: r,
          onClick: () => u.execute(e),
          disabled: !p
        }
      )
    ] }, `increment-${e}`);
  }
), Kt = g(Te, (e) => {
  const n = ye.styles(e.variants), o = (e == null ? void 0 : e.increments) || [
    {
      incrementWith: 1
    }
  ];
  return /* @__PURE__ */ a("div", { className: n.wrapper, children: o.map((r, i) => /* @__PURE__ */ He(Dt, { ...r, ...e, key: i })) });
}), Be = t.object({
  template: t.literal("dropdown-on-hover"),
  variants: t.custom().optional()
}), Nt = g(
  Be,
  ({ variants: e }) => {
    const n = X();
    return Fe.styles(e), /* @__PURE__ */ a("div", { className: "absolute flex z-30 group-hover:translate-y-0 translate-y-full bottom-0 transition-transform duration-300 left-0 right-0 bg-page-surface", children: n.optionGroups.map((o) => /* @__PURE__ */ a(
      "div",
      {
        className: "grid grid-cols-5 px-4 py-2 w-full",
        children: o.options.map((r) => /* @__PURE__ */ a(
          "button",
          {
            onClick: () => console.log(r.label),
            className: "text-black cols-span-1 text-sm py-2 hover:bg-white",
            children: r.label
          }
        ))
      },
      o.dimensionKey
    )) });
  }
), Pt = {
  available: "PLP_Add_To_Cart",
  "out-of-stock": "PLP_Out_Of_Stock",
  discontinued: "PLP_Discontinued",
  "not-determined": "PLP_Select_Size"
}, Le = () => {
  const e = ne(), n = A(), o = Pt[e.status] ?? "PLP_Select_Size";
  return n(o);
}, xt = {
  width: "full",
  color: "primary"
}, We = t.object({
  template: t.literal("one-size-button"),
  variants: t.custom().optional().describe("Variants for the one size button"),
  buttonVariants: ot.shape.variants.optional().describe("Variants for the button")
}), Et = N(
  "OneSizeButton",
  g(
    We,
    ({ variants: e, buttonVariants: n = xt }) => {
      const o = Re.styles(e), { addToCartMethod: r, isAvailable: i } = re(), c = ne().status === "out-of-stock", l = A(), u = Le(), d = async () => {
        if (c) {
          he.error(l("PLP_Add_To_Cart_Error_Out_Of_Stock_Toast"));
          return;
        }
        if (!i) {
          he.error(l("PLP_Add_To_Cart_Error_Not_Available_Toast"));
          return;
        }
        try {
          await r.execute();
        } catch (p) {
          console.error(p);
        }
      };
      return /* @__PURE__ */ a(
        "div",
        {
          className: o.base,
          "data-is-out-of-stock": c ? "true" : "false",
          children: /* @__PURE__ */ a(
            q,
            {
              onClick: d,
              label: u,
              progress: r.loadingState,
              dataAttr: { "appear-disabled": c },
              variants: n
            }
          )
        }
      );
    }
  )
), Tt = {
  direction: "bottom",
  variants: {
    rounded: "subtle"
  }
}, Ae = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional().describe("Variants for the drawer"),
  displayHeading: t.boolean().optional().describe("Display the title of the drawer"),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttons: $.optional(),
  addToCartButton: $.optional(),
  oneSizeButton: $.optional(),
  alwaysDisplayAddToCartButton: t.boolean().optional().describe("Always display the add to cart button"),
  showWhenOutOfStock: t.boolean().optional().describe(
    "Show the quickshop trigger even when out of stock (for back-in-stock functionality)"
  ),
  postAddAction: t.union([t.literal("showMinicart"), t.literal("none")]).optional().describe("Action to perform after adding the product to the cart"),
  trigger: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional().describe(
    "The trigger for the drawer, can be a string, a component or an element"
  ),
  aboveAddToCartButtonComponent: t.custom().optional(),
  belowAddToCartButtonComponent: t.custom().optional(),
  wrapper: t.custom().optional().describe(
    "A component that wraps the entire drawer. Receives { children, isOpen }"
  )
}), Bt = () => {
  const [e, n] = J(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return fe(() => {
    const o = () => {
      n(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", o), () => window.removeEventListener("resize", o);
  }, []), e;
}, Lt = ({
  variants: e,
  displayHeading: n,
  buttons: o,
  addToCartButton: r,
  alwaysDisplayAddToCartButton: i,
  showWhenOutOfStock: s,
  postAddAction: c,
  aboveAddToCartButtonComponent: l,
  belowAddToCartButtonComponent: u
}) => {
  const d = T(), p = we(), b = X(), { addToCartMethod: h, isOutOfStock: w } = re(), f = ue(), S = Le(), B = ne(), O = de(), D = A(), y = ce.styles(e), Z = typeof window < "u" && window.location.pathname.includes("/checkout"), Y = async () => {
    if (!w) {
      try {
        await h.execute();
      } catch (C) {
        console.error("Error adding to cart:", C);
        return;
      }
      c === "showMinicart" && !Z && (G.emit("close", { overlayId: "quickshop-drawer" }), setTimeout(() => {
        G.emit("open", { overlayId: "mini-cart" });
      }, 300));
    }
  }, _ = p == null ? void 0 : p[0], H = f.price.number < f.priceWithoutDiscount.number, L = b.optionGroups.length > 1;
  return !O && !s ? null : /* @__PURE__ */ m(
    "div",
    {
      className: y.baseWrapper,
      "data-has-multiple-options": L ? "true" : "false",
      children: [
        n && /* @__PURE__ */ a("div", { className: y.header, children: /* @__PURE__ */ a("h3", { className: y.heading, children: D("Quickshop_Drawer_Heading") }) }),
        /* @__PURE__ */ m("div", { className: y.productInfo, children: [
          _ && /* @__PURE__ */ a(Ie, { className: y.productImage, image: _ }),
          /* @__PURE__ */ a("h4", { className: y.productName, children: d.content.name }),
          /* @__PURE__ */ m("div", { className: y.productPriceWrapper, children: [
            /* @__PURE__ */ a(
              "span",
              {
                "data-is-discounted": H ? "true" : "false",
                className: y.productPrice,
                children: f.price.formatted
              }
            ),
            H && /* @__PURE__ */ a("span", { className: y.productPriceBeforeDiscount, children: f.priceWithoutDiscount.formatted })
          ] })
        ] }),
        /* @__PURE__ */ a("div", { className: y.optionGroupsWrapper, children: b.optionGroups.map((C) => /* @__PURE__ */ m(
          "div",
          {
            className: y.wrapper,
            "data-dimension-key": C.dimensionKey,
            "data-dimension-label": C.dimensionLabel,
            children: [
              /* @__PURE__ */ a("span", { className: y.sizeLabel, children: D(L ? `Size_Picker_${C.dimensionLabel}` : "Quickshop_Select_Size") }),
              /* @__PURE__ */ a("div", { className: y.sizes, children: C.options.map((v, I) => /* @__PURE__ */ a(
                Pe,
                {
                  option: v,
                  optionGroup: C,
                  className: y.size,
                  action: L || i ? "selectOption" : "addToCart",
                  buttons: o
                },
                `${v.label}-${I}`
              )) })
            ]
          },
          C.dimensionKey
        )) }),
        l,
        (L || i) && /* @__PURE__ */ a(
          nt,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...r,
            progress: h.loadingState,
            dataAttr: {
              "appear-disabled": B.status !== "available"
            },
            disabled: B.status !== "available",
            label: S,
            onClick: Y,
            className: y.addToCartButton
          }
        ),
        u
      ]
    }
  );
}, Wt = (e) => {
  const {
    variants: n,
    displayHeading: o,
    drawerSettings: r,
    trigger: i,
    buttons: s,
    addToCartButton: c,
    alwaysDisplayAddToCartButton: l,
    showWhenOutOfStock: u,
    postAddAction: d,
    aboveAddToCartButtonComponent: p,
    onDrawerOpenChange: b,
    wrapper: h,
    isOpen: w
  } = e, f = Bt(), S = ce.styles(n);
  if (!de() && !u)
    return null;
  const O = () => typeof i == "string" || k.isValidElement(i) ? i : typeof i == "function" ? /* @__PURE__ */ a(i, {}) : null;
  return /* @__PURE__ */ m(
    se,
    {
      customOverlayId: "quickshop-drawer",
      ...r,
      direction: f ? "right" : "bottom",
      onOpenChange: b,
      variants: (r == null ? void 0 : r.variants) && {
        ...r.variants,
        ...f ? { direction: "right" } : { direction: "bottom" }
      },
      children: [
        /* @__PURE__ */ a(
          se.Trigger,
          {
            className: S.trigger,
            "data-is-one-size": "false",
            "aria-label": "Open quickshop drawer",
            children: O()
          }
        ),
        /* @__PURE__ */ a(se.Content, { children: (() => {
          const D = /* @__PURE__ */ a(Lt, { ...e });
          return h ? /* @__PURE__ */ a(h, { isDrawerOpen: w, children: D }) : D;
        })() })
      ]
    }
  );
}, At = (e) => {
  const { variants: n, trigger: o, postAddAction: r, oneSizeButton: i } = e, s = ce.styles(n), { addToCartMethod: c, isOutOfStock: l } = re(), [u, d] = J(!1), [p, b] = J(!1), h = typeof window < "u" && window.location.pathname.includes("/checkout"), w = async () => {
    if (!l) {
      try {
        d(!0), await c.execute(), b(!0), setTimeout(() => {
          d(!1), b(!1);
        }, 1e3);
      } catch (S) {
        console.error("Error adding to cart:", S), d(!1), b(!1);
        return;
      }
      r === "showMinicart" && !h && (G.emit("close", { overlayId: "quickshop-drawer" }), setTimeout(() => {
        G.emit("open", { overlayId: "mini-cart" });
      }, 300));
    }
  }, f = () => typeof o == "string" || k.isValidElement(o) ? o : typeof o == "function" ? /* @__PURE__ */ a(o, {}) : null;
  return /* @__PURE__ */ a("span", { className: s.trigger, "data-is-one-size": "true", children: /* @__PURE__ */ a(
    q,
    {
      variants: {
        color: "white",
        rounded: "md",
        size: "sm"
      },
      dataAttr: {
        "is-on-size": "true"
      },
      ariaLabel: "Add to cart",
      onClick: w,
      disabled: u,
      progress: p ? "complete" : u ? "loading" : "default",
      label: f(),
      ...i
    }
  ) });
}, zt = N(
  "QuickshopDrawer",
  g(
    {
      schema: Ae,
      defaultProps: {
        template: "drawer",
        drawerSettings: Tt,
        buttons: {
          variants: {
            style: "outline",
            color: "primary",
            rounded: "md",
            size: "sm"
          }
        },
        displayHeading: !0,
        postAddAction: "none",
        alwaysDisplayAddToCartButton: !1,
        showWhenOutOfStock: !1
      }
    },
    (e) => {
      const n = Se(), [o, r] = J(!1);
      if (n === "with_variants")
        return /* @__PURE__ */ a(
          Wt,
          {
            ...e,
            onDrawerOpenChange: r,
            isOpen: o
          }
        );
      if (n === "simple")
        return /* @__PURE__ */ a(At, { ...e });
    }
  )
), ze = t.discriminatedUnion("template", [
  xe,
  Be,
  We,
  Ae,
  Te
]), je = g(ze, (e) => {
  switch (e.template) {
    case "button-grid":
      return /* @__PURE__ */ a(It, { ...e });
    case "dropdown-on-hover":
      return /* @__PURE__ */ a(Nt, { ...e });
    case "one-size-button":
      return /* @__PURE__ */ a(Et, { ...e });
    case "drawer":
      return /* @__PURE__ */ a(zt, { ...e });
    case "increment":
      return /* @__PURE__ */ a(Kt, { ...e });
    default:
      return null;
  }
}), jt = t.object({
  sizesCount: t.object({
    from: t.number(),
    to: t.number()
  }).describe(
    "If a product has the number of sizes specified as a range, show the supplied template"
  ),
  optionsCount: t.object({
    from: t.number(),
    to: t.number()
  }).describe(
    "If a product has the number of options specified as a range, show the supplied template"
  )
});
function be(e, n) {
  const o = e.map((s) => s.options.length);
  o.sort();
  const r = o[o.length - 1];
  if (typeof r > "u")
    return !1;
  const i = e.length;
  return r >= n.sizesCount.from && r <= n.sizesCount.to && i >= n.optionsCount.from && i <= n.optionsCount.to;
}
const Ot = {
  "button-grid": {
    sizesCount: {
      from: 2,
      to: 10
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  "dropdown-on-hover": {
    sizesCount: {
      from: 2,
      to: 10
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  "one-size-button": {
    sizesCount: {
      from: 0,
      to: 1
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  drawer: {
    sizesCount: {
      from: 1,
      to: 20
    },
    optionsCount: {
      from: 1,
      to: 5
    }
  },
  increment: {
    sizesCount: {
      from: 0,
      to: 10
    },
    optionsCount: {
      from: 0,
      to: 5
    }
  }
}, _t = t.object({
  config: jt,
  template: ze
}), x = t.object({
  configs: t.array(_t).optional().describe("The configuration for the quickshop")
}), oe = (e) => {
  const n = Se();
  switch (n) {
    case "with_variants":
      return /* @__PURE__ */ a(Ht, { configs: e.configs });
    case "simple":
      return /* @__PURE__ */ a(Mt, { configs: e.configs });
    case "bundle":
      return null;
    default:
      return console.error(`Unknown product data model "${n}"`), null;
  }
}, Ht = (e) => {
  var r;
  const { optionGroups: n } = X(), o = (r = e.configs) == null ? void 0 : r.filter(
    (i) => (
      // First, check that the template supports the product options
      be(
        n,
        Ot[i.template.template]
      ) && // Then, check that the supplied config supports the product options
      be(n, i.config)
    )
  );
  return !o || o.length === 0 ? null : /* @__PURE__ */ a(E, { children: o.map((i, s) => /* @__PURE__ */ a(je, { ...i.template }, s)) });
}, Mt = (e) => {
  var o;
  const n = (o = e.configs) == null ? void 0 : o.filter(
    (r) => r.config.sizesCount.from <= 1
  );
  return !n || n.length === 0 ? null : /* @__PURE__ */ a(E, { children: n.map((r, i) => /* @__PURE__ */ a(je, { ...r.template }, i)) });
}, $t = {
  configs: [
    {
      config: {
        sizesCount: {
          from: 2,
          to: 10
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "button-grid",
        variants: {
          placeIn: "gallery"
        }
      }
    },
    {
      config: {
        sizesCount: {
          from: 2,
          to: 20
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "drawer",
        variants: {
          placeIn: "gallery"
        }
      }
    },
    {
      config: {
        sizesCount: {
          from: 0,
          to: 1
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "one-size-button",
        variants: {
          placeIn: "gallery"
        }
      }
    }
  ]
}, qt = {
  configs: [
    {
      config: {
        sizesCount: {
          from: 0,
          to: 1
        },
        optionsCount: {
          from: 0,
          to: 1
        }
      },
      template: {
        template: "one-size-button",
        variants: {
          placeIn: "details"
        }
      }
    }
  ]
}, Gt = {
  gallery: $t,
  details: qt
}, Qt = t.object({
  blueprint: t.custom().optional(),
  /**
   * The template to use for the product card component (default is "1")
   */
  template: t.literal("1"),
  variants: t.custom().optional(),
  productInfoText: ge.optional(),
  /**
   * Gallery configuration
   */
  gallery: me.optional().describe("Details configuration"),
  /**
   * Details configuration
   */
  details: pe.optional().describe("Details configuration"),
  /**
   * Badges configuration
   */
  badges: Q.omit({ location: !0 }).optional().describe("Badges configuration"),
  /**
   * Swatches configuration
   */
  swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
  /**
   * Quickshop configuration
   */
  quickshop: t.object({
    gallery: x.optional(),
    details: x.optional()
  }).optional().describe("Quickshop configuration"),
  /**
   * Price configuration
   */
  price: F.omit({ variants: !0, styling: !0 }).optional().describe("Price configuration"),
  wishlist: V.optional().describe("Wishlist configuration"),
  /**
   * Reviews configuration
   */
  reviewStarsSlot: t.custom().optional().describe("Reviews configuration")
}), Vt = N(
  "ProductCardTemplate1",
  g(
    {
      schema: Qt,
      defaultProps: {
        template: "1",
        quickshop: Gt
      }
    },
    ({
      badges: e,
      variants: n,
      price: o,
      quickshop: r,
      swatches: i,
      blueprint: s,
      details: c,
      productInfoText: l,
      gallery: u,
      reviewStarsSlot: d
    }) => {
      const b = (s ?? W).main.styles(n), h = Ye();
      return /* @__PURE__ */ m("div", { className: b.wrapper, children: [
        /* @__PURE__ */ m(ke, { styling: W.gallery, ...u, children: [
          /* @__PURE__ */ a(te, { ...e, location: "gallery" }),
          /* @__PURE__ */ a(ae, { ...i, location: "gallery" }),
          !h && /* @__PURE__ */ a(oe, { ...r == null ? void 0 : r.gallery })
        ] }),
        /* @__PURE__ */ m(De, { styling: W.details, ...c, children: [
          d,
          /* @__PURE__ */ a(Ke, { styling: W.details }),
          /* @__PURE__ */ a(
            Ne,
            {
              ...o,
              styling: W.details,
              variants: c == null ? void 0 : c.variants
            }
          ),
          /* @__PURE__ */ a(
            vt,
            {
              styling: W.details,
              ...l
            }
          ),
          /* @__PURE__ */ a(ae, { ...i, location: "details" }),
          /* @__PURE__ */ a(
            te,
            {
              ...e,
              location: "details",
              styling: W.details
            }
          ),
          !h && /* @__PURE__ */ a(oe, { ...r == null ? void 0 : r.details })
        ] })
      ] });
    }
  )
), Ft = t.object({
  variants: t.custom().optional(),
  styling: t.custom().optional()
}), Rt = g(Ft, (e) => {
  const {
    content: { shortDescription: n }
  } = T(), r = (e.styling ?? U).styles(e.variants);
  return n ? /* @__PURE__ */ a("p", { className: r.shortDescription, children: n }) : null;
}), Ut = {
  details: {
    configs: [
      {
        config: {
          sizesCount: {
            from: 0,
            to: 1
          },
          optionsCount: {
            from: 0,
            to: 1
          }
        },
        template: { template: "increment" }
      }
    ]
  }
}, Ca = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), Xt = t.object({
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional()
}), Zt = N(
  "AttributesAsProgressBar",
  g(
    Xt,
    ({
      variants: e,
      features: n = {
        onAScaleOf: 10
      }
    }) => {
      const o = A(), r = Ue.styles(e), i = Je(
        "progress-bar",
        t.string()
      );
      return i != null && i.value ? /* @__PURE__ */ a("div", { className: r.base, children: /* @__PURE__ */ m("div", { className: r.item, children: [
        /* @__PURE__ */ a("div", { className: r.bar, children: /* @__PURE__ */ a(
          Ce.div,
          {
            className: r.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${parseInt(i.value) / n.onAScaleOf * 100}%`
            },
            exit: { width: 0 }
          }
        ) }),
        /* @__PURE__ */ a("span", { className: r.label, children: o(i == null ? void 0 : i.attributeLabel) })
      ] }) }) : null;
    }
  )
), Yt = t.object({
  /**
   * The template to use for the product card component (default is "default")
   */
  template: t.literal("2"),
  variants: t.custom().optional(),
  /**
   * Badges configuration
   */
  badges: Q.optional().describe("Badges configuration"),
  /**
   * Swatches configuration
   */
  swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
  /**
   * Quickshop configuration
   */
  quickshop: t.object({
    gallery: x.optional(),
    details: x.optional()
  }).optional().describe("Quickshop configuration"),
  /**
   * Price configuration
   */
  price: F.optional().describe("Price configuration"),
  wishlist: V.optional().describe("Wishlist configuration"),
  outOfStock: t.object({
    badge: ee.optional(),
    text: t.string().optional()
  }).optional()
}), Jt = g(
  {
    schema: Yt,
    defaultProps: {
      template: "2"
    }
  },
  ({
    badges: e,
    variants: n,
    price: o,
    quickshop: r = Ut,
    swatches: i,
    outOfStock: s
  }) => {
    const { status: c } = ne(), l = A(), u = P.main.styles(n);
    return /* @__PURE__ */ m("div", { className: u.wrapper, children: [
      /* @__PURE__ */ m(ke, { styling: P.gallery, children: [
        /* @__PURE__ */ a(
          te,
          {
            ...e,
            location: "gallery",
            styling: P.badges
          }
        ),
        /* @__PURE__ */ a(Zt, {}),
        /* @__PURE__ */ a(ae, { ...i, location: "gallery" }),
        /* @__PURE__ */ a(Ne, { styling: P.details, ...o }),
        /* @__PURE__ */ a(oe, { ...r == null ? void 0 : r.gallery }),
        c === "out-of-stock" && /* @__PURE__ */ a("div", { className: u.outOfStockBadge, children: /* @__PURE__ */ a(
          M,
          {
            label: l("ProductCard_Out_Of_Stock_Badge"),
            ...s == null ? void 0 : s.badge
          }
        ) })
      ] }),
      /* @__PURE__ */ m(De, { styling: P.details, children: [
        /* @__PURE__ */ a(
          te,
          {
            ...e,
            location: "details",
            styling: P.badges
          }
        ),
        /* @__PURE__ */ a(Ke, { styling: P.details }),
        /* @__PURE__ */ a(Rt, { styling: P.details }),
        /* @__PURE__ */ a(ae, { ...i, location: "details" }),
        /* @__PURE__ */ a(oe, { ...r == null ? void 0 : r.details })
      ] })
    ] });
  }
), Oe = t.discriminatedUnion(
  "template",
  [
    // Template 1
    t.object({
      template: t.literal("1"),
      variants: t.custom().optional(),
      /**
       * Details configuration
       */
      details: pe.optional().describe("Details configuration"),
      productInfoText: ge.optional(),
      /**
       * Gallery configuration
       */
      gallery: me.optional().describe("Gallery configuration"),
      /**
       * Badges configuration
       */
      badges: Q.omit({ location: !0 }).optional().describe("Badges configuration"),
      /**
       * Swatches configuration
       */
      swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
      /**
       * Quickshop configuration
       */
      quickshop: t.object({
        gallery: x.optional(),
        details: x.optional()
      }).optional().describe("Quickshop configuration"),
      /**
       * Price configuration
       */
      price: F.omit({ variants: !0, styling: !0 }).optional().describe("Price configuration"),
      wishlist: V.optional().describe("Wishlist configuration"),
      /**
       * Reviews configuration
       */
      reviewStarsSlot: t.custom().optional().describe("Reviews configuration")
    }),
    // Template 2
    t.object({
      /**
       * The template to use for the product card component (default is "default")
       */
      template: t.literal("2"),
      variants: t.custom().optional(),
      /**
       * Badges configuration
       */
      badges: Q.optional().describe("Badges configuration"),
      /**
       * Swatches configuration
       */
      swatches: R.omit({ location: !0 }).optional().describe("Swatches configuration"),
      /**
       * Quickshop configuration
       */
      quickshop: t.object({
        gallery: x.optional(),
        details: x.optional()
      }).optional().describe("Quickshop configuration"),
      /**
       * Price configuration
       */
      price: F.optional().describe("Price configuration"),
      wishlist: V.optional().describe("Wishlist configuration"),
      outOfStock: t.object({
        badge: ee.optional(),
        text: t.string().optional()
      }).optional()
    })
  ]
), ea = g(
  Oe,
  (e) => {
    switch (e.template) {
      case "1":
        return /* @__PURE__ */ a(Vt, { ...e });
      case "2":
        return /* @__PURE__ */ a(Jt, { ...e });
      default:
        return null;
    }
  }
), ta = "1", aa = t.object({
  templateProps: Oe.optional()
}), ka = N(
  "ProductCard",
  g(aa, (e) => {
    const n = e.templateProps || { template: ta };
    return /* @__PURE__ */ a(ea, { ...n });
  })
), oa = t.object({
  from: t.number(),
  to: t.number()
}).describe("In what size range should the quickshop be shown"), Da = t.object({
  /**
   * In between what sizes should the quickshop be shown.
   */
  sizeRange: oa.optional()
}), Ka = {
  dataModel: "with_variants",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "6090",
      description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
      shortDescription: "New Balance",
      media: [
        {
          type: "image",
          src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
          alt: "Image 2"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 3"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 4"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 5"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        },
        {
          label: "Sale",
          badgeType: "sale",
          backgroundColor: "#00000000",
          textColor: "#000000"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://cdn11.bigcommerce.com/s-ijskllcnjp/images/stencil/1920w/products/27212/28528/RA9582-00-5QY-01__99676.1715931980.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ],
  variants: [
    {
      label: "XXL",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "XXL",
          valueLabel: "XXL"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "S",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "S",
          valueLabel: "S"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "XS",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-07-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-1",
      variantKey: "v-1",
      sku: "sku-1",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "XS",
          valueLabel: "XS"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    }
  ]
}, Na = {
  dataModel: "with_variants",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "6090",
      description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
      shortDescription: "New Balance",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
          alt: "Image 2"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 3"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 4"
        },
        {
          type: "image",
          src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
          alt: "Image 5"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        },
        {
          label: "Sale",
          badgeType: "sale",
          backgroundColor: "#ffffff",
          textColor: "#000000"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "1243131",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "1246",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ],
  variants: [
    {
      label: "38",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-38",
      variantKey: "v-38",
      sku: "sku-38",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "38",
          valueLabel: "38"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    {
      label: "39",
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-39",
      variantKey: "v-39",
      sku: "sku-39",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "39",
          valueLabel: "39"
        }
      ],
      inventory: {
        quantity: 10,
        inStock: !0,
        warehouseId: "wh-1"
      },
      additionalInventory: []
    },
    // Continue with sizes 40 to 45 following the same pattern
    {
      label: "40",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-40",
      variantKey: "v-40",
      sku: "sku-40",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "40",
          valueLabel: "40"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "41",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-41",
      variantKey: "v-41",
      sku: "sku-41",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "41",
          valueLabel: "41"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "42",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-42",
      variantKey: "v-42",
      sku: "sku-42",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "42",
          valueLabel: "42"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "43",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-43",
      variantKey: "v-43",
      sku: "sku-43",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "43",
          valueLabel: "43"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "44",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-44",
      variantKey: "v-44",
      sku: "sku-44",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "44",
          valueLabel: "44"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "45",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "46",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    },
    {
      label: "47",
      additionalInventory: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: [
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          },
          {
            date: /* @__PURE__ */ new Date("2024-08-01"),
            price: { formatted: "1000 SEK", number: 1e3 },
            priceWithoutDiscount: {
              formatted: "1 0000 SEK",
              number: 1e4
            }
          }
        ]
      },
      mainProductId: "123",
      mainProductKey: "123",
      variantId: "v-45",
      variantKey: "v-45",
      sku: "sku-45",
      dimensions: [
        {
          dimensionKey: "size",
          dimensionLabel: "Size",
          value: "45",
          valueLabel: "45"
        }
      ],
      inventory: { quantity: 10, inStock: !0, warehouseId: "wh-1" }
    }
  ]
}, Pa = {
  dataModel: "with_variants",
  base: {
    slug: "product-slug",
    productId: "product-id",
    productKey: "product-key",
    discontinued: !1,
    content: {
      name: "6090",
      description: "",
      shortDescription: "",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
          alt: "Image 1"
        }
      ],
      badges: []
    },
    attributes: [],
    categories: []
  },
  variants: [
    {
      dimensions: [],
      priceInfo: {
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        },
        previouslyDiscountedPrices: []
      },
      label: "variant label",
      mainProductId: "product-id",
      mainProductKey: "product-key",
      variantId: "variant-id",
      variantKey: "variant-key",
      sku: "sku",
      inventory: {
        quantity: 100,
        inStock: !0,
        warehouseId: "1"
      },
      additionalInventory: []
    }
  ],
  siblingProducts: []
}, xa = {
  dataModel: "simple",
  isBundle: !1,
  inventory: {
    quantity: 10,
    inStock: !0,
    warehouseId: "wh-1"
  },
  priceInfo: {
    price: { formatted: "1000 SEK", number: 1e3 },
    priceWithoutDiscount: {
      formatted: "1 0000 SEK",
      number: 1e4
    },
    previouslyDiscountedPrices: [
      {
        date: /* @__PURE__ */ new Date("2024-08-01"),
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        }
      },
      {
        date: /* @__PURE__ */ new Date("2024-07-01"),
        price: { formatted: "1000 SEK", number: 1e3 },
        priceWithoutDiscount: {
          formatted: "1 0000 SEK",
          number: 1e4
        }
      }
    ]
  },
  sku: "sku-38",
  additionalInventory: [],
  itemId: "item-onesize",
  base: {
    productId: "1234",
    productKey: "1234",
    slug: "product",
    discontinued: !1,
    content: {
      name: "Gaut Messenger Bag",
      description: "",
      shortDescription: "Klättermusen",
      media: [
        {
          type: "image",
          src: "https://i.ibb.co/hdwRqvS/40460-U21-587-01-51766.jpg",
          alt: "Image 1"
        },
        {
          type: "image",
          src: "https://i.ibb.co/CHhNxRv/40460-U21-587-02-24628.jpg",
          alt: "Image 2"
        }
      ],
      badges: [
        {
          label: "New In",
          badgeType: "new",
          backgroundColor: "#ffffff",
          textColor: "#000000",
          imageSrc: "https://example.com/badge1.png"
        }
      ]
    },
    attributes: [],
    categories: [
      {
        name: "Category 1",
        slug: "category1",
        categoryId: "cat1"
      },
      {
        name: "Category 2",
        slug: "category1/category2",
        categoryId: "cat2"
      }
    ]
  },
  siblingProducts: [
    {
      productId: "1234",
      productKey: "124",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#161316"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1234551",
      productKey: "1243123",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#605960"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "1236",
      productKey: "124515",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#FE673E"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    },
    {
      productId: "12348",
      productKey: "12431131",
      slug: "product-1",
      discontinued: !1,
      content: {
        name: "6090",
        description: "Check out the New Balance 6090 - it's not just a shoe, it's a game changer. With its super comfy cushioning and durable design, it's perfect for both workouts and everyday wear. Plus, it looks pretty sleek too. Give the 6090 a try and feel the New Balance difference.",
        shortDescription: "New Balance",
        media: [
          {
            type: "image",
            src: "https://i.ibb.co/2SdBcTD/Comp-F-Image2.jpg",
            alt: "Image 1"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1621315271772-28b1f3a5df87",
            alt: "Image 2"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 3"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 4"
          },
          {
            type: "image",
            src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606",
            alt: "Image 5"
          }
        ],
        badges: [
          {
            label: "New In",
            badgeType: "new",
            backgroundColor: "#ffffff",
            textColor: "#000000",
            imageSrc: "https://example.com/badge1.png"
          },
          {
            label: "Sale",
            badgeType: "sale",
            backgroundColor: "#00000000",
            textColor: "#000000"
          }
        ]
      },
      attributes: [
        {
          attributeLabel: "colorSwatchHex",
          attributeKey: "colorSwatchHex",
          valueLabel: "colorSwatchHex",
          value: "#D0D0D0"
        }
      ],
      categories: [
        {
          name: "Category 1",
          slug: "category1",
          categoryId: "cat1"
        },
        {
          name: "Category 2",
          slug: "category1/category2",
          categoryId: "cat2"
        }
      ]
    }
  ]
};
export {
  Zt as AttributesAsProgressBar,
  te as Badges,
  It as ButtonGrid,
  De as DetailsWrapper,
  ct as DotIndicator,
  Nt as DropdownOnHover,
  ke as Gallery,
  ut as GalleryIndicator,
  dt as IconHeart,
  Ct as IconMinus,
  kt as IconPlus,
  Kt as Increment,
  Ke as Name,
  Et as OneSizeButton,
  Ne as Price,
  pt as PriceAsBadge,
  gt as PriceAsSpanProps,
  ka as ProductCard,
  vt as ProductInfoText,
  Pe as QuickshopButton,
  zt as QuickshopDrawer,
  At as QuickshopDrawerSimple,
  oe as QuickshopSelector,
  je as QuickshopTemplate,
  Pt as STATUS_TRANSLATIONS,
  lt as ScrollIndicator,
  ea as SelectTemplate,
  Rt as ShortDescription,
  wt as Swatch,
  ae as Swatches,
  Vt as Template1,
  Jt as Template2,
  Ia as WishlistTrigger,
  Xt as attributesAsProgressBarSchema,
  Ca as attributesProgressBarItemSchema,
  Q as badgesSchema,
  pe as detailsSchema,
  Ka as discountedExampleProduct,
  me as gallerySchema,
  Ee as incrementRow,
  Na as mockData,
  Pa as mockDataMinimal,
  xa as onesSizeMockData,
  F as priceSchema,
  aa as productCardPropsSchema,
  Oe as productCardSchema,
  ge as productInfoTextSchema,
  be as productOptionsMatchesQuickshopTemplate,
  St as quickshopButtonSchema,
  Ae as quickshopDrawerSchema,
  Be as quickshopDropdownOnHoverSchema,
  xe as quickshopGridSchema,
  Te as quickshopIncrementSchema,
  We as quickshopOneSizeButtonSchema,
  _t as quickshopSelectorConfig,
  x as quickshopSelectorProps,
  jt as quickshopTemplateOptionsSupport,
  Ot as quickshopTemplateSupportConfig,
  ze as quickshopTemplatesSchema,
  Da as sharedConfig,
  R as swatchesSchema,
  Gt as template1QuickshopConfig,
  Qt as template1Schema,
  Ut as template2QuickshopConfig,
  Yt as template2Schema,
  Le as useAddToCartLabel,
  st as useScrollBounds,
  it as useSwipeHint,
  V as wishlistTriggerSchema
};
//# sourceMappingURL=index.es.js.map
